import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
  Alpine.data('initReviewBlock', () => {
    return {
      moreContent: false,
      showBtn: false,
      totalContent: false,
      start() {
        if (this.$refs.clamp) {
          const content = this.$refs.clamp.offsetHeight;

          if (content <= 72) {
            this.moreContent = false;
            this.showBtn = false;
          } else {
            this.moreContent = true;
            this.showBtn = true;
            this.totalContent = false;
          }
        }
      }
    }
  })
});
